import { setWidthOfBar } from "./functions";

function addTestDataIdsToElementsInSingleProductPage() {
  // Add data-testid for li elements inside .flex-control-thumbs
  const flexControlThumbs = document.querySelectorAll(
    ".flex-control-thumbs li"
  );
  flexControlThumbs.forEach((li, index) => {
    li.setAttribute("data-testid", `flex-control-thumb-${index}`);
  });

  // Add data-testid for the first div inside .woocommerce-product-gallery__wrapper
  const productGalleryWrapper = document.querySelector(
    ".woocommerce-product-gallery__wrapper > div"
  );
  if (productGalleryWrapper) {
    productGalleryWrapper.setAttribute(
      "data-testid",
      "singleProduct-product-gallery-wrapper-div"
    );
  }

  const priceAmounts = document.querySelectorAll(".woocommerce-Price-amount");
  priceAmounts.forEach((div, index) => {
    div.setAttribute("data-testid", `singleProduct-price-amount-${index}`);
  });

  const secondTrDiv = document.querySelector(
    ".variations tbody tr:nth-child(2) td div"
  );
  if (secondTrDiv) {
    secondTrDiv.setAttribute("data-testid", "singleProduct-second-tr-div");
  }

  const fourthTrDiv = document.querySelector(
    ".variations tbody tr:nth-child(4) td div"
  );
  if (fourthTrDiv) {
    fourthTrDiv.setAttribute("data-testid", "singleProduct-fourth-tr-div");
  }

  const quantityDiv = document.querySelector(".quantity");
  if (quantityDiv) {
    quantityDiv.setAttribute("data-testid", "singleProduct-quantity-div");
  }

  const addToCart = document.querySelector(".single_add_to_cart_button");
  if (addToCart) {
    addToCart.setAttribute(
      "data-testid",
      "singleProduct-singleProduct-add-to-cart"
    );
  }

  const relatedProductsSection = document.querySelector(".related-products");
  if (relatedProductsSection) {
    relatedProductsSection.setAttribute(
      "data-testid",
      "singleProduct-related-products-section"
    );
  }

  const productsUl = document.querySelector("ul.products");
  if (productsUl) {
    productsUl.setAttribute("data-testid", "singleProduct-products-ul");

    const productLiList = productsUl.querySelectorAll("li");
    productLiList.forEach((li, index) => {
      li.setAttribute("data-testid", `singleProduct-product-li-${index}`);
    });
  }
}

function addTestDataIdsToElementsInShopPage() {
  const selectOptionsUl = document.querySelector("ul.select-options");
  if (selectOptionsUl) {
    selectOptionsUl.setAttribute("data-testid", "select-options-ul");

    const selectOptionsLiList = selectOptionsUl.querySelectorAll("li");
    selectOptionsLiList.forEach((li, index) => {
      li.setAttribute("data-testid", `select-options-li-${index}`);
    });
  }

  const productsUl = document.querySelector("ul.products");
  if (productsUl) {
    productsUl.setAttribute("data-testid", "products-ul");

    const productLiList = productsUl.querySelectorAll("li");
    productLiList.forEach((li, index) => {
      li.setAttribute("data-testid", `product-li-${index}`);
    });
  }
}

function addTestDataAttributesInCheckoutPage() {
  const elements = document.querySelectorAll(
    ".input-text, .wc_payment_method.payment_method_cod, #payment_method_cybsawm, .wc_payment_method.payment_method_cybsawm, .woocommerce-privacy-policy-text, #terms, #place_order"
  );

  elements.forEach((element) => {
    if (element.id) {
      element.setAttribute("data-testid", element.id);
    } else if (element.classList.length > 0) {
      const classes = Array.from(element.classList).join(" ");
      element.setAttribute("data-testid", classes);
    }
  });

  const table = document.querySelector(
    ".shop_table.woocommerce-checkout-review-order-table"
  );

  if (table) {
    table.setAttribute("data-testid", "shop_table");
    const elements = ["thead", "tbody", "tfoot"];
    elements.forEach((elementName) => {
      const element = table.querySelector(elementName);
      if (element) {
        const rows = element.querySelectorAll("tr");
        rows.forEach((row, rowIndex) => {
          row.setAttribute("data-testid", `${elementName}-${rowIndex}`);
          const cells = row.querySelectorAll("th, td");
          cells.forEach((cell, cellIndex) => {
            cell.setAttribute(
              "data-testid",
              `${elementName}-${rowIndex}-${cellIndex}`
            );
          });
        });
      }
    });
  }
}

function addTestDataIdsToElementsInCartPage() {
  const cartTable = document.querySelector(".shop_table");
  if (cartTable) {
    cartTable.setAttribute("data-testid", "cart-table");

    ["thead", "tbody", "tfoot"].forEach((section) => {
      const tableSection = cartTable.querySelector(section);
      if (tableSection) {
        const rows = tableSection.querySelectorAll("tr");
        rows.forEach((row, rowIndex) => {
          row.setAttribute(
            "data-testid",
            `cart-table-${section}-row-${rowIndex}`
          );
          const cells = row.querySelectorAll("th, td");
          cells.forEach((cell, cellIndex) => {
            cell.setAttribute(
              "data-testid",
              `cart-table-${section}-row-${rowIndex}-cell-${cellIndex}`
            );
          });
        });
      }
    });
  }

  const cartTotalsTable = document.querySelectorAll(".shop_table")[1];
  if (cartTotalsTable) {
    cartTotalsTable.setAttribute("data-testid", "cart-totals-table");

    ["thead", "tbody", "tfoot"].forEach((section) => {
      const tableSection = cartTotalsTable.querySelector(section);
      if (tableSection) {
        const rows = tableSection.querySelectorAll("tr");
        rows.forEach((row, rowIndex) => {
          row.setAttribute(
            "data-testid",
            `cart-totals-table-${section}-row-${rowIndex}`
          );
          const cells = row.querySelectorAll("th, td");
          cells.forEach((cell, cellIndex) => {
            cell.setAttribute(
              "data-testid",
              `cart-totals-table-${section}-row-${rowIndex}-cell-${cellIndex}`
            );
          });
        });
      }
    });
  }

  const checkoutButtonDiv = document.querySelector(
    ".checkout-button.button.alt.wc-forward"
  );
  if (checkoutButtonDiv) {
    checkoutButtonDiv.setAttribute("data-testid", "checkout-button-div");
  }
}

function waitForWooCommerceLoad(callback) {
  const checkExist = setInterval(function () {
    const woocommerceContent = document.querySelector(".blockUI");
    if (!woocommerceContent) {
      clearInterval(checkExist);
      callback();
    }
  }, 500);
}

if (document.URL.includes("/checkout")) {
  document.addEventListener("DOMContentLoaded", function () {
    waitForWooCommerceLoad(addTestDataAttributesInCheckoutPage);
  });
}

if (document.URL.includes("/cart")) {
  document.addEventListener("DOMContentLoaded", function () {
    waitForWooCommerceLoad(addTestDataIdsToElementsInCartPage);
  });
}

if (document.URL.includes("/shop")) {
  document.addEventListener("DOMContentLoaded", function () {
    waitForWooCommerceLoad(addTestDataIdsToElementsInShopPage);
  });
}

if (document.URL.includes("/product")) {
  document.addEventListener("DOMContentLoaded", function () {
    waitForWooCommerceLoad(addTestDataIdsToElementsInSingleProductPage);
  });
}

function loadStylesheet(url) {
  var link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = url;
  document.head.appendChild(link);
}

function loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  script.onload = callback;
  document.head.appendChild(script);
}

jQuery(document).ready(function ($) {
  const component = $(".woocommerce-products-header");
  const section = $(".shop_section");
  $(window).on("load", function () {
    if (window.location.href.indexOf("/product/") > -1) {
      var productsCtrClass = $("#custom-product-card").closest("ul");
      productsCtrClass.removeClass("columns-4");
      productsCtrClass.addClass("columns-2");
    }
    const thumbnails = $(".flex-control-nav");

    if (thumbnails.find("li").length > 4 && $(window).width() > 768) {
      thumbnails.addClass("swiperJS swiper");
      var productGalleryImage = $(".woocommerce-product-gallery__image");

      if (productGalleryImage.length > 0) {
        var galleryImageHeight = productGalleryImage.height();
        if (galleryImageHeight > 1000) {
          galleryImageHeight = galleryImageHeight / 10;
        }
        $(".flex-control-nav").css("height", galleryImageHeight + "px");
      }
      thumbnails.find("li").wrapAll('<div class="swiper-wrapper"></div>');
      thumbnails.find("li").addClass("swiper-slide");
      var nextButton = $('<div class="swiper-button-next"></div>');
      var prevButton = $('<div class="swiper-button-prev"></div>');

      thumbnails.append(nextButton);
      thumbnails.append(prevButton);

      loadStylesheet(
        "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"
      );
      loadScript(
        "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js",
        function () {
          const swiper = new Swiper(".swiper", {
            direction: "vertical",
            loop: false,
            slidesPerView: 4,

            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });

          nextButton.on("click", function () {
            swiper.slideNext();
          });

          prevButton.on("click", function () {
            swiper.slidePrev();
          });
        }
      );
    }
  });

  if (section.length > 0) {
    setWidthOfBar("woocommerce-products-header__inner", "nav");
    $(window).on(
      "resize",
      setWidthOfBar("woocommerce-products-header__inner", "nav")
    );

    const originalPosition = section.offset().top;
    const sectionHeight = section.outerHeight();
    const offset = 150;

    $(window).on("scroll", function () {
      const scrollTop = $(window).scrollTop();
      const endPosition =
        originalPosition + sectionHeight - component.outerHeight();

      if ($("#wpadminbar").length == 0) {
        if (
          scrollTop >= originalPosition - offset &&
          scrollTop <= endPosition
        ) {
          component.addClass("fixed").removeClass("fixed_with_admin_bar");
        } else {
          component.removeClass("fixed");
        }
      } else {
        if (
          scrollTop >= originalPosition - offset &&
          scrollTop <= endPosition
        ) {
          component.addClass("fixed_with_admin_bar").removeClass("fixed");
        } else {
          component.removeClass("fixed_with_admin_bar");
        }
      }
    });
  }

  $(".orderby").each(function () {
    var $this = $(this),
      numberOfOptions = $(this).children("option").length;

    $this.addClass("select-hidden");
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next("div.select-styled");

    // Function to update selected text
    function updateSelectedText() {
      var selectedText = $this.children("option:selected").text();
      $styledSelect.text(selectedText);
    }

    updateSelectedText();

    var $list = $("<ul />", {
      class: "select-options",
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
      $("<li />", {
        text: $this.children("option").eq(i).text(),
        rel: $this.children("option").eq(i).val(),
      }).appendTo($list);
      if ($this.children("option").eq(i).is(":selected")) {
        $('li[rel="' + $this.children("option").eq(i).val() + '"]').addClass(
          "is-selected"
        );
      }
    }

    var $listItems = $list.children("li");

    $styledSelect.click(function (e) {
      e.stopPropagation();
      $("div.select-styled.active")
        .not(this)
        .each(function () {
          $(this).removeClass("active").next("ul.select-options").hide();
        });
      $(this).toggleClass("active").next("ul.select-options").toggle();
    });

    $listItems.click(function (e) {
      e.stopPropagation();
      var selectedOption = $(this).attr("rel");
      $styledSelect.text($(this).text()).removeClass("active");
      $this.val(selectedOption).change(); // Update the original select element
      $list.find("li.is-selected").removeClass("is-selected");
      $list.find('li[rel="' + selectedOption + '"]').addClass("is-selected");
      $list.hide();
    });

    $(document).click(function () {
      $styledSelect.removeClass("active");
      $list.hide();
    });

    // Update selected text when original select value changes
    $this.change(function () {
      updateSelectedText();
    });
  });

  let addToCart = $(".single_add_to_cart_button");
  let variationForm = $(".variations_form");
  variationForm.on("hide_variation", function (e) {
    setTimeout(() => {
      addToCart.removeClass("wc-variation-selection-needed");
    }, 1000);
  });
});
